'use client';
import { useTranslations } from 'next-intl';
import React from 'react';

const LinkDropdown = ({ links }) => {
  const t = useTranslations('');

  const handleLinkChange = (event) => {
    const selectedUrl = event.target.value;
    if (selectedUrl) {
      window.open(selectedUrl, '_blank');
      event.target.selectedIndex = 0; // Reset dropdown
    }
  };

  if (!links || links.length === 0) {
    return (
      <div>
        <label htmlFor="link-dropdown" id="link" className="hidden mb-1 text-sm font-medium text-gray-700">
          {t('home.selectLink')}
        </label>

        <select aria-labelledby="link" id="link-dropdown" disabled className="w-full p-2 border border-gray-300 rounded bg-gray-100 text-gray-500">
          <option>Không có liên kết</option>
        </select>
      </div>
    );
  }

  return (
    <div>
      <label htmlFor="link-dropdown" id="link-active" className="hidden  mb-1 text-sm font-medium text-gray-700">
        {t('home.selectLink')}
      </label>

      <select
        aria-labelledby="link-active"
        id="link-dropdown"
        onChange={handleLinkChange}
        defaultValue=""
        className="w-full p-2 border border-gray-300 rounded bg-white cursor-pointer">
        <option value="" disabled>
          {t('home.selectLink')}
        </option>
        {links.map((link) => (
          <option key={link.id} value={link.url}>
            {link.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LinkDropdown;
